const oneDayWidth = 2.4;

export default {
    oneDayWidth,
};
